import { useEffect, useState, type SyntheticEvent } from "react";

import type { IPlaybackModel, TInvestigationTab } from "./investigation.models";
import { resolveOpeningTab } from "./investigation.utils";

/** The info panel's active tab: where a ride opens, what playback focuses, and the reset on close. */
export const useInvestigationPanelTab = ({
  model,
  isOpen,
  isPlaying,
  canReadHistory,
}: {
  model?: IPlaybackModel;
  isOpen: boolean;
  isPlaying: boolean;
  canReadHistory: boolean;
}) => {
  const [tab, setTab] = useState<TInvestigationTab>("summary");
  const rideId = model?.rideId;
  const hasGps = model?.hasGps;

  const onTabChange = (
    _event: SyntheticEvent,
    value: TInvestigationTab,
  ): void => setTab(value);

  // Once per ride, when its payload lands — the trail arriving later rebuilds the model but keeps both values.
  useEffect(() => {
    if (rideId !== undefined && hasGps !== undefined) {
      setTab(resolveOpeningTab({ hasGps, canReadHistory }));
    }
  }, [rideId, hasGps, canReadHistory]);

  // Starting playback focuses the Stations tab so you follow the vehicle station-by-station.
  useEffect(() => {
    if (isPlaying) {
      setTab("stations");
    }
  }, [isPlaying]);

  // Closing resets the active tab so the next open starts clean.
  useEffect(() => {
    if (!isOpen) {
      setTab("summary");
    }
  }, [isOpen]);

  return { tab, onTabChange };
};
